import request from '@/utils/request'

export function login (data) {
  return request({
    url: 'api/login_submit',
    method: 'POST',
    data
  })
}

export function registerApi (data) {
  return request({
    url: 'api/register_submit',
    method: 'POST',
    data
  })
}
// 检查回调url
export function checkAppCallbackUrlApi (data) {
  return request({
    url: '/admin/common/check_app_callback_url',
    method: 'POST',
    data
  })
}
